import { useNavigate } from "react-router-dom";
import css from "./Home.module.css"
import {useEffect} from "react";

const HomePage = () => {
    const navigate = useNavigate();

    document.body.style.zoom = 1

    const particles = Array.from({length: 30}, (_, i) => (
        <div className={css.particle} key={i}
            style={{left: Math.random() * 100 + "%", animationDelay: Math.random() * 15 + "s", animationDuration: (Math.random() * 10 + 10) + "s"}}>
        </div>
    ));

    useEffect(() => {
        const hero = document.getElementById("heroContent");
        document.addEventListener("mousemove", function (e) {
            const x = (e.clientX / window.innerWidth - 0.5) * 5;
            const y = (e.clientY / window.innerHeight - 0.5) * 5;
            hero.style.transform = `rotateY(${x}deg) rotateX(${-y}deg)`;
        })

        document.addEventListener('mouseleave', () => {
            hero.style.transform = 'rotateY(0deg) rotateX(0deg)';
        });
    })

    return (
        <>
            <div className={css.bgGrid}></div>
            <div className={`${css.bgGlow} ${css.bgGlow1}`}></div>
            <div className={`${css.bgGlow} ${css.bgGlow2}`}></div>
            <div className={css.particles} id="particles">
                {particles}
            </div>

            <div className={css.wrap}>

                <section className={css.hero}>
                    <div className={css.heroContent} id="heroContent">
                        <div className={css.badge}>VPN нового поколения</div>
                        <h1>Secure Internet</h1>
                        <p className={css.heroSub}>Молниеносный VPN-сервис с шифрованием трафика. Ваши данные под
                            защитой!</p>

                        <div className={css.priceBlock}>
                            <span className={css.priceLabel}>Цена</span>
                            <span className={css.price}>139 ₽</span>
                            <span className={css.pricePeriod}>в месяц</span>
                        </div>

                        <div className={css.cta}>
                            <button className={`${css.btn} ${css.btnPrimary}`} onClick={() => navigate("/buy")}>
                                Купить подписку
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"
                                     stroke-linecap="round" stroke-linejoin="round">
                                    <line x1="5" y1="12" x2="19" y2="12"/>
                                    <polyline points="12 5 19 12 12 19"/>
                                </svg>
                            </button>
                            <a href="#" className={`${css.btn} ${css.btnGhost}`}>
                                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                     stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
                                    <path d="M21 19a2 2 0 0 1-2 2h-1v-6h3v4zM3 19a2 2 0 0 0 2 2h1v-6H3v4z"/>
                                </svg>
                                Техподдержка
                            </a>
                        </div>
                    </div>
                </section>

                <section className={css.features}>
                    <div className={css.feature}>
                        <div className={css.featureIcon}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
                            </svg>
                        </div>
                        <h3>Молниеносная скорость</h3>
                        <p>Оптимизированные серверы обеспечивают скорость до 1 Гбит/с без задержек и буферизации.</p>
                    </div>

                    <div className={css.feature}>
                        <div className={css.featureIcon}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                            </svg>
                        </div>
                        <h3>Шифрование SHA-256</h3>
                        <p>Ваша активность полностью анонимна и недоступна для
                            отслеживания. Пакеты шифруются согласно мировым стандартам защиты данных.</p>
                    </div>

                    <div className={css.feature}>
                        <div className={css.featureIcon}>
                            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                 stroke-linecap="round" stroke-linejoin="round">
                                <path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"/>
                                <path d="M12 6v6l4 2"/>
                            </svg>
                        </div>
                        <h3>Без логов</h3>
                        <p>Мы не храним историю ваших подключений. Полная конфиденциальность и никаких следов вашей
                            активности.</p>
                    </div>
                </section>

            </div>
        </>
    );
};


export default HomePage;